<template>
  <div class="staff-info-container">
    <div v-if="localStaff" class="staff-edit">
      <div class="action-pane">
        <div class="w-70 staff-header px-3">
          <h5 class="title my-0">{{ $t("feature.staff.edit") }}</h5>
          <span>ID: {{ localStaff.adminId }}</span>
        </div>
        <div class="w-30 mx-3">
          <button
            v-if="localStaff.isActive"
            class="sc-btn sc-btn-opaque"
            @click="saveStaffInfo"
          >
            {{ $t("feature.staff.save") }}
          </button>
          <span v-else class="inactived">{{
            $t("feature.staff.inactived")
          }}</span>
        </div>
      </div>
      <section class="staff-meta">
        <div class="form">
          <dl class="form-options">
            <dt>โปรไฟล์</dt>
            <dd>
              <label class="align-right">
                <span>อีเมล</span>
                <el-input v-model="localStaff.email" type="text"></el-input>
              </label>
            </dd>
            <dd>
              <label class="align-right">
                <span>ชื่อ</span>
                <el-input v-model="localStaff.firstName" type="text"></el-input>
              </label>
            </dd>
            <dd>
              <label class="align-right">
                <span>สกุล</span>
                <el-input v-model="localStaff.lastName" type="text"></el-input>
              </label>
            </dd>
            <dd>
              <label class="align-right">
                <span>ใช้ email password</span>
                <el-checkbox v-model="localStaff.isCorpPass"></el-checkbox>
              </label>
            </dd>
            <dd>
              <label class="align-right">
                <span>Referral Code</span>
                <el-input
                  v-model="localStaff.referralCode"
                  type="text"
                ></el-input>
              </label>
            </dd>
          </dl>
        </div>
      </section>
      <section class="staff-actions">
        <div class="form">
          <dl v-if="localStaff.isActive" class="form-options">
            <dt>แก้ไขการใช้งาน</dt>
            <dd>
              <button
                class="sc-btn sc-btn-outline w-30"
                @click="dialogs.inactiveStaffDialog.isShow = true"
              >
                ยกเลิกการใช้งาน
              </button>
            </dd>
            <dd>
              <button
                v-show="!showPasswordBox"
                class="sc-btn sc-btn-outline w-30"
                @click="showPasswordBox = true"
              >
                เปลี่ยนรหัสผ่าน
              </button>
              <div v-if="showPasswordBox" class="change-password-box">
                <dt>เปลี่ยนรหัสผ่าน</dt>
                <dd>
                  <label class>
                    <span>กรอกรหัสผ่านใหม่</span>
                    <el-input
                      v-model="newPassword"
                      type="text"
                      class="mx-3"
                      placeholder="ความยาวตั้งแต่ 8 ตัวอักษรขึ้นไป"
                    ></el-input>
                  </label>
                  <button
                    v-if="showPasswordBox"
                    class="sc-btn sc-btn-opaque w-30"
                    @click="changeStaffPassword"
                  >
                    บันทึกรหัสผ่านใหม่
                  </button>
                </dd>
              </div>
            </dd>
          </dl>
        </div>
      </section>
      <section class="staff-features">
        <div class="form">
          <dl class="form-options">
            <dt>การเข้าถึง</dt>
            <dd class="staff-role">
              <label class="label">Role</label>
              <role-selector
                v-model="localStaff.roleId"
                :roles="roles"
              ></role-selector>
            </dd>
            <dd
              v-show="isShowFinancialInstitution"
              class="financial-institution-role"
            >
              <label class="label">สถาบันการเงิน</label>
              <financial-institution-selector
                v-model="localStaff.financialInstitutionId"
                :financial-institutions="financialInstitutions"
              ></financial-institution-selector>
            </dd>
          </dl>
          <div class="provider">
            <label class="label">ผู้ให้บริการ</label>
            <multiple-provider-selector
              v-if="isRuejaiPartnerAdminRole"
              v-model="localStaff"
              @providerIds="handleSelectedProviders"
              @isSelectedAllProviders="handleSelectedAllProviders"
            />
            <provider-selector
              v-else
              v-model="localStaff.provider"
              :disabled="isDisableSelectProvider"
            />
          </div>
        </div>
      </section>
      <section v-show="isShowArticleRole" class="staff-article-role">
        <div class="form">
          <dl class="form-options">
            <dt>ข่าว / บทความ</dt>
            <ArticleRoleSelector
              v-model="localStaff.articleRole"
              :is-creating-staff="false"
              :roles="roles"
              :staff-role-id="localStaff.roleId"
            ></ArticleRoleSelector>
          </dl>
        </div>
      </section>
      <section v-show="isShowProjectSelector" class="staff-projects">
        <project-selector
          :input-projects="localStaff.projects"
          @setProjects="saveProjects"
        ></project-selector>
      </section>
      <confirm-dialog
        v-show="dialogs.inactiveStaffDialog.isShow"
        :data="dialogs.inactiveStaffDialog.data"
        :is-h-t-m-l="dialogs.inactiveStaffDialog.isHTML"
        name="inactiveStaffDialog"
        @confirm="dialogs.inactiveStaffDialog.confirm"
      ></confirm-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import { Input, Checkbox } from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import ProjectSelector from "@/components/helper/ProjectSelector"
import ProviderSelector from "@/lib/components/ProviderSelector"
import MultipleProviderSelector from "@/lib/components/MultipleProviderSelector"
import { isEmpty } from "ramda"
import { getCookie, Auth } from "@/lib/cookie"
import ArticleRoleSelector from "./components/ArticleRoleSelector"
import FinancialInstitutionSelector from "./components/FinancialInstitutionSelector"
import RoleSelector from "./components/RoleSelector"

export default {
  components: {
    ProjectSelector,
    RoleSelector,
    FinancialInstitutionSelector,
    ArticleRoleSelector,
    "el-input": Input,
    "el-checkbox": Checkbox,
    "provider-selector": ProviderSelector,
    "multiple-provider-selector": MultipleProviderSelector,
  },
  props: {
    staff: {
      type: Object,
      default: undefined,
    },
    roles: {
      type: Array,
      default: undefined,
    },
    financialInstitutions: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      localStaff: null,
      editedData: {
        account: {},
        projects: [],
      },
      showPasswordBox: false,
      newPassword: null,
      dialogs: {
        inactiveStaffDialog: {
          isShow: false,
          isHTML: false,
          data: {
            title: "ยกเลิกการใช้งาน",
            detail: "ต้องการยกเลิกการใช้งาน account นี้ใช่หรือไม่?",
            buttonCancel: "ไม่ใช่",
            buttonSubmit: "ใช่",
          },
          confirm: this.inactiveStaff,
        },
      },
    }
  },
  computed: {
    features() {
      if (this.roles) {
        const adminRole = this.roles.filter((r) => r.role === "Admin")
        const allFeatures = adminRole[0].admin_features

        return allFeatures
      }

      return []
    },
    selectedRoleFeatures() {
      if (this.roles && this.localStaff && this.localStaff.roleId) {
        const role = this.roles.find(
          (r) => r.role_id === this.localStaff.roleId,
        ).admin_features

        return role
      }

      return []
    },
    isShowArticleRole() {
      const articleFeatures = this.selectedRoleFeatures.map((f) => f.feature_id)
      return articleFeatures.some((e) => e <= 3)
    },
    isShowProjectSelector() {
      if (!this.roles || !this.localStaff || !this.localStaff.roleId) {
        return false
      }

      const roleName = this.roles.find(
        ({ role_id: roleId }) => roleId === this.localStaff.roleId,
      ).role_name

      return ![
        "Admin",
        "Call Center",
        "Home care",
        "Accounting",
        "Financial Institution",
      ].includes(roleName)
    },
    isShowFinancialInstitution() {
      if (!this.roles || !this.localStaff || !this.localStaff.roleId) {
        return false
      }

      const roleName = this.roles.find(
        (role) => role.role_id === this.localStaff.roleId,
      ).role_name

      return ["Financial Institution"].includes(roleName)
    },
    isDisableSelectProvider() {
      return (
        !this.localStaff ||
        !this.localStaff.roleId ||
        !(this.localStaff.roleId === 18)
      )
    },
    isRuejaiPartnerAdminRole() {
      return this.localStaff && this.localStaff.roleId === 20
    },
    isSelectedManageProviderIds() {
      return this.localStaff && !isEmpty(this.localStaff.manageProviderIds)
    },
    isSelectedAllProviders() {
      return this.localStaff && this.localStaff.canManageAllProviders
    },
  },
  watch: {
    staff: {
      immediate: true,
      handler(staff) {
        if (staff) {
          this.localStaff = {
            ...staff,
            provider: staff.provider ? { ...staff.provider } : null,
            manageProviderIds: staff.manageProviderIds
              ? [...staff.manageProviderIds]
              : [],
            projects: staff.projects ? [...staff.projects] : [],
          }
          this.editedData.projects = staff.projects ? [...staff.projects] : []
        } else {
          this.localStaff = null
          this.editedData.projects = []
        }
      },
    },
    $route() {
      this.showPasswordBox = false
      this.newPassword = null
    },
  },
  methods: {
    handleSelectedProviders(providerIds) {
      this.localStaff.manageProviderIds = providerIds
    },
    handleSelectedAllProviders(isSelectedAllProviders) {
      this.localStaff.manageProviderIds = []
      this.localStaff.canManageAllProviders = isSelectedAllProviders
    },
    saveProjects(projects) {
      if (projects) {
        const projectArray = Object.values(projects)
        this.editedData.projects = projectArray.map((p) =>
          parseInt(p.projectId, 10),
        )
      }
    },
    saveAccount() {
      this.editedData.account = {
        email: this.localStaff.email,
        firstName: this.localStaff.firstName,
        lastName: this.localStaff.lastName,
        isCorpPass: this.localStaff.isCorpPass,
        referralCode: this.localStaff.referralCode,
        articleRole: parseInt(this.localStaff.articleRole, 10),
        roleId: parseInt(this.localStaff.roleId, 10),
        financialInstitutionId: this.localStaff.financialInstitutionId,
        providerId:
          this.localStaff.roleId === 18 &&
          this.localStaff.provider &&
          this.localStaff.provider.id
            ? +this.localStaff.provider.id
            : null,
        manageProviderIds:
          this.localStaff.roleId === 20 && this.isSelectedManageProviderIds
            ? this.localStaff.manageProviderIds
            : null,
        canManageAllProviders:
          this.localStaff.roleId === 20 && this.isSelectedAllProviders
            ? this.localStaff.canManageAllProviders
            : false,
      }
    },
    async saveStaffInfo() {
      if (
        this.isRuejaiPartnerAdminRole &&
        !(this.isSelectedManageProviderIds || this.isSelectedAllProviders)
      ) {
        this.$message.error("กรุณาเลือกผู้ให้บริการ หรือ กดเลือกทั้งหมด")

        return
      }

      this.saveAccount()
      this.saveProjects()

      try {
        await axios.put(
          `${process.env.HOST}/admin/staffs/${this.localStaff.adminId}`,
          {
            account: this.editedData.account,
            projects: this.editedData.projects,
          },
          {
            headers: {
              Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
            },
          },
        )

        this.$emit("update:staff")
      } catch (e) {
        this.$message.error("Could not update staff profiles")
        throw e
      }
    },
    async changeStaffPassword() {
      if (this.newPassword.length < 8) {
        this.$message.error(
          "กรุณาใช้รหัสผ่านที่มีความยาวตั้งแต่ 8 ตัวอักษรขึ้นไป",
        )
        return
      }

      try {
        await axios.put(
          `${process.env.HOST}/admin/staffs/${
            this.localStaff.adminId
          }/password/change`,
          {
            newPassword: this.newPassword,
          },
          {
            headers: {
              Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
            },
          },
        )

        this.showPasswordBox = false
        this.newPassword = null
        this.$emit("update:staff")
      } catch (e) {
        this.$message.error("ตรวจสอบรหัสผ่านใหม่ ความยาว 8 ตัวอักษรขึ้นไป")
        throw e
      }
    },
    async inactiveStaff(confirm) {
      if (confirm) {
        try {
          await axios.delete(
            `${process.env.HOST}/admin/staffs/${this.localStaff.adminId}`,
            {
              headers: {
                Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
              },
            },
          )

          this.$emit("update:staff")
        } catch (e) {
          this.$message.error("Inactive staff failed")
          throw e
        }
      }

      this.dialogs.inactiveStaffDialog.isShow = false
    },
  },
}
</script>

<style lang="scss" scoped>
.staff-info-container {
  font-size: 16px;
  background-color: $white;
  padding: 0;
  overflow: scroll;

  .staff-header {
    padding: 10px 0;

    h5 {
      font-size: 17px;
    }

    span {
      font-size: 11px;
    }
  }

  section {
    padding: 16px;
    border-top: 1px solid #e0e0e0;
  }

  dl {
    margin: 0;

    dt {
      margin-bottom: 8px;
      color: $black;
      font-size: 16px;
    }

    dd {
      label.align-right > span {
        display: inline-block;
        width: 7em;
        text-align: right;
        margin-right: 8px;
      }

      &.two-columns {
        display: table-caption;
        column-count: 2;
        margin-left: 76px;

        .select-input > span:last-child {
          width: 168px;
          display: inline-block;
        }
      }

      &.one-column {
        display: table-caption;
        column-count: 1;
        margin-left: 76px;

        .select-input > span:first-child {
          width: 30em;
          display: inline-block;
        }
      }
    }
  }

  .action-pane {
    display: flex;
    align-items: center;
  }

  .w-30 {
    display: inline-block;
    width: 30%;
  }

  .w-70 {
    display: inline-block;
    width: 69.5%;
  }

  .el-input {
    width: 210px;
  }

  .select-input.disabled {
    cursor: not-allowed;
  }

  .inactived {
    color: $red;
    font-weight: bold;
    line-height: 40px;
  }

  .change-password-box {
    padding: 16px;
    border-radius: 16px;
    border: 1px solid #ddd;
  }
}

.staff-role {
  display: grid;
  grid-template-columns: 64px 1fr;
  grid-gap: 12px;

  > .label {
    margin-top: 5px;
    text-align: right;
  }
}

.financial-institution-role {
  display: grid;
  grid-template-columns: 97px 1fr;
  grid-gap: 12px;

  > .label {
    margin-top: 5px;
    text-align: right;
  }
}
</style>
